import { Form } from '@dfl/mui-react-common';
import { useSecurity } from '@dfl/react-security';
import { IphoneSwitchField } from 'modules/common/components/IphoneSwitchField';
import { PRODUCT_PERMISSIONS } from '../../constants';
import useUpdateProductTop from 'modules/inventory/product/hooks/useUpdateProductTop';
import { memo, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';

type Props = {
  value?: boolean;
  productId: string;
};

const ProductTopPicker = ({ value, productId }: Props) => {
  const { hasPermission } = useSecurity();
  const { control, watch, reset } = useForm({ defaultValues: { top: !!value } });
  const { updateTop, isLoading } = useUpdateProductTop(productId);

  useEffect(() => {
    reset({ top: !!value });
  }, [value, reset]);

  const handleChange = useCallback(() => {
    updateTop(!value);
  }, [updateTop, value]);

  return (
    <Form id='product-top-form' control={control} watch={watch}>
      <IphoneSwitchField
        sx={{ mr: '0px !important' }}
        name={'top'}
        label={undefined}
        onChange={handleChange}
        isLoading={isLoading}
        disabled={isLoading || !hasPermission(PRODUCT_PERMISSIONS.PRODUCT_WRITE)}
      />
    </Form>
  );
};

export default memo(ProductTopPicker);
